/**
 * useOperationsHubCount — Returns the total pending operations count for the hub badge.
 * Polls every 30 seconds.
 */
import { useState, useEffect, useCallback, useRef } from 'react';
import { getOperationsHubSummary } from '../api/allocationApi';
import { useAuth } from '../context/AuthContext';

export default function useOperationsHubCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const intervalRef = useRef(null);

  const isStaff = user && ['admin', 'ict_manager', 'jr_engineer', 'sr_engineer'].includes(user.role);

  const fetchCount = useCallback(async () => {
    if (!isStaff) { setCount(0); return; }
    try {
      const { data } = await getOperationsHubSummary();
      setCount(data.total || 0);
    } catch {
      // silent
    }
  }, [isStaff]);

  useEffect(() => {
    fetchCount();
    intervalRef.current = setInterval(fetchCount, 30_000);
    return () => clearInterval(intervalRef.current);
  }, [fetchCount]);

  return count;
}
